module.exports = __webpack_public_path__ + "static/img/4.47f5f69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/4.png
// module id = XTn6
// module chunks = 0